export const formatTimeToIST = (timestamp) => {
  if (!timestamp) return '';

  try {
    // If it's an ISO string (e.g. "2026-06-30T15:32:05.251802Z"), we want to show 
    // the exact time we get in the string without adding 5:30 hrs timezone offset.
    if (typeof timestamp === 'string' && timestamp.includes('T')) {
      // Parse as UTC to prevent timezone offset conversion
      return new Date(timestamp).toLocaleTimeString('en-IN', {
        timeZone: 'UTC',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }

    const timestampInMs = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
    
    return new Date(timestampInMs).toLocaleTimeString('en-IN', {
      timeZone: 'Asia/Kolkata',  // Convert to IST
      hour12: false,  // 24-hour format
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch (err) {
    console.error('Error formatting time to IST:', err);
    return timestamp?.toString() || '';  // Return original value if parsing fails
  }
};

export const formatOrderUpdateTime = (item, isTrade = false) => {
  if (!item) return '';

  if (isTrade || item.tradeId || item.trade_time !== undefined) {
    const tradeTime = item.trade_time;
    if (tradeTime && tradeTime !== 0 && tradeTime !== '0') {
      return formatTimeToIST(tradeTime);
    }
    return formatTimeToIST(item.order_entry_time);
  }

  const ref = item.last_activity_reference;
  if (ref && ref !== 0 && ref !== '0') {
    try {
      const refStr = ref.toString();
      const ms = refStr.length >= 13 ? Math.floor(Number(ref) / 1000000) : Number(ref);
      return formatTimeToIST(ms);
    } catch (err) {
      // fall through
    }
  }
  return formatTimeToIST(item.order_entry_time);
}; 